/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

class ImageParamsKeyMap {
  private _map:
    | { [key: string]: string | ((data: any) => [string, string]) }
    | undefined;

  get map() {
    return this._map;
  }

  set map(value: typeof this._map) {
    this._map = value;
  }

  public getMethods() {
    return {
      setMap: (value: typeof this._map) => {
        this.map = value;
      },
      getMap: () => this.map,
    };
  }
}

const keyMap = new ImageParamsKeyMap();

export const { setMap: setImageParamsKeyMap, getMap: getImageParamsKeyMap } =
  keyMap.getMethods();
